import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BaseRequestService, ResponseList } from '@outlaw/core';
import { CommunityConfigService } from '../util';
import { Observable } from 'rxjs';
import { CommentCreateData } from '../../interfaces/comment-create';
import { CommentEditData } from '../../interfaces/comment-edit';
import { CommentsBulk } from '../../interfaces/comment-bulk';
import { CommentItem } from '../../interfaces/comment-item';

@Injectable({ providedIn: 'root' })
export class CommentService {
  #internalApi = inject(CommunityConfigService).internalApi;
  postUrl = this.#internalApi.postUrl;

  #http = inject(HttpClient);
  #baseRequestService = inject(BaseRequestService);

  getPostComments(postId: string, cursor?: string): Observable<ResponseList<CommentItem>> {
    return this.#baseRequestService.pagedCursorGet<CommentItem>([this.postUrl, postId, 'comments'], cursor);
  }

  createPostComment(postId: string, commentData: CommentCreateData): Observable<CommentItem> {
    return this.#http.post<CommentItem>(
      this.#baseRequestService.prepareUrl([this.postUrl, postId, 'comments', 'create']),
      commentData
    );
  }

  likeComment(commentId: string): Observable<any> {
    return this.#http.post(this.#baseRequestService.prepareUrl([this.postUrl, 'comments', commentId, 'like']), null);
  }

  dislikeComment(commentId: string): Observable<any> {
    return this.#http.delete(this.#baseRequestService.prepareUrl([this.postUrl, 'comments', commentId, 'like']));
  }

  bulkCommentsCount(postIds: string[]): Observable<CommentsBulk> {
    let params = new HttpParams();
    params = params.append('posts_uuids', postIds.join(','));
    return this.#http.get<CommentsBulk>(this.#baseRequestService.prepareUrl([this.postUrl, 'comments', 'count_bulk']), {
      params,
    });
  }

  deleteComment(commentId: string): Observable<any> {
    return this.#http.delete(this.#baseRequestService.prepareUrl([this.postUrl, 'comments', commentId, 'delete']));
  }

  updateComment(commentId: string, commentData: CommentEditData): Observable<any> {
    return this.#http.put(
      this.#baseRequestService.prepareUrl([this.postUrl, 'comments', commentId, 'update']),
      commentData
    );
  }
}
